import $ from 'jquery';

$(document).ready(function() {
	$(document).on('click', '.js-review-info-button', function() {
		$('.js-modal-review').show();
		$('body').addClass('fixed-position-modal');
	});
	$(document).on('click', '.js-modal-review-close', function() {
		$('.js-modal-review').hide();
		$('body').removeClass('fixed-position-modal');
	});
	$(document).on('click', '.js-modal-review', function(e) {
		if (!((e.target).closest('.js-modal-review-wrap'))) {
			$('.js-modal-review').hide();
			$('body').removeClass('fixed-position-modal');
		}
	});
});


// WEBPACK FOOTER //
// ./src/js/pages/reviews/modal-review.js